import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { IoAddOutline } from "react-icons/io5";
import {
  DeleteAPICall,
  postAPICall,
  putAPICall,
  setToastRef,
  showErrorToast,
  showSuccessToast,
  // showToast,
} from "../Api/Api";
import { Panel } from "primereact/panel";
import { Toast } from "primereact/toast";
import GlobalPopup from "../GlobalComponents/GlobalPopup";
import { MdModeEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import "./AdminStyle.css";
export default function ToMailConfiguration(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [emailAddresses, setEmailAddresses] = useState([]);
  const [tooMailDataSource, setTooMailDataSource] = useState([]);
  const [editedItems, setEditedItems] = useState(null);
  const [to, setTo] = useState("");
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [errors, setErrors] = useState({
    to: "",
    emailAddresses: "",
  });
  const toast = useRef(null);
  useEffect(() => {
    setToastRef(toast.current);

    if (props?.toMailSenderId || props?.refreshConfirmation == true) {
      GetTooMail();
    }
  }, [
    props?.toMailSenderId,
    props?.toMailDataRemove,
    props?.refreshConfirmation,
  ]);

  const GetTooMail = async () => {
    if (props.toMailSenderId || props?.refreshConfirmation == true) {
      const requestBody = {
        senderId: props?.toMailSenderId,
        accountGroupCode: parseInt(props.toMailAccountGroupCode),
      };
      const response = await postAPICall(
        "api/Configuration/GetTooEmailDetail",
        requestBody
      );
      if (response?.data) {
        setTooMailDataSource(response?.data);
      }
    }
  };

  const filteredToomailDataSource = tooMailDataSource?.filter((mail) =>
    mail.RecipientEmail.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // setTooMailFilterDataSource(filteredToomailDataSource);

  const handlePopupOpen = () => {
   
    if (props?.toMailSenderId != null) {
      setEditedItems(null);
      setErrors({});
      setShowDialog(true);
    } else {
      showErrorToast("Please Select From Email !!");
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleAddEmail = () => {
    if (validateEmail(to)) {
      setEmailAddresses((prev) => [...prev, to.trim()]);
      setErrors((prev) => ({
        ...prev,
        to: "",
        emailAddresses: "",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        to: "Please enter a valid email address.",
      }));
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      setEditedItems(null);
      handleAddEmail();
    } else if (e.key === "Backspace" && !to) {
      setEmailAddresses((prev) => prev.slice(0, -1));
    }
  };

  const handleRemoveEmail = (index) => {
    setEmailAddresses((prev) => prev?.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    let isValid = true;
    let newErrors = {};

    // Safeguard: Ensure emailAddresses and editedItems.RecipientEmail are valid arrays/strings
    const emailToValidate =
      emailAddresses?.length > 0
        ? emailAddresses
        : [editedItems?.RecipientEmail]?.filter(Boolean);

    // Validate if any email is provided
    if (emailToValidate.length === 0) {
      newErrors.emailAddresses =
        "At least one recipient email address is required.";
      isValid = false;
    }

    // Check if email addresses exist and validate each
    const invalidEmails = emailToValidate?.filter(
      (email) => !validateEmail(email)
    );
    if (invalidEmails.length > 0) {
      newErrors.emailAddresses = `Invalid email addresses: ${invalidEmails.join(
        ", "
      )}`;
      isValid = false;
    }

    // If validation fails, set errors and stop further execution
    if (!isValid) {
      setErrors(newErrors);
      return;
    }

    // If the data is valid, proceed with API calls
    if (editedItems?.RecipientId == null) {
      const requestBody = {
        toMail: emailAddresses,
        senderId: props?.toMailSenderId,
        accountGroupCode: parseInt(props?.toMailAccountGroupCode),
      };

      const response = await postAPICall(
        "api/Configuration/PostToMailConfiguration",
        requestBody
      );
      if (response.status === 200) {
        GetTooMail();
        setShowDialog(false);
        setErrors({});
        setEmailAddresses([]);
        showSuccessToast("Recipient mail added successfully...");
      }
    } else {
      const requestBody = {
        toMailSinlge: editedItems.RecipientEmail,
        recipientId: editedItems.RecipientId,
      };

      const response = await putAPICall(
        "api/Configuration/PutToMailConfiguration",
        requestBody
      );
      if (response.status === 200) {
        GetTooMail();
        setShowDialog(false);
        showSuccessToast("Recipient mail updated successfully...");
      }
    }
  };

  const AddNewToMailFooter = (
    <div>
      <Button
        id="BtnSave"
        label="Save"
        icon="pi pi-check"
        onClick={handleSave}
        autoFocus
      />
      <Button
        id="BtnCancel"
        label="Cancel"
        icon="pi pi-times"
        onClick={() => setShowDialog(false)}
        className="p-button-text"
      />
    </div>
  );
  const handleInputTooEmail = (e) => {
    const { value } = e.target;
    setTo(value);
    setEditedItems((prevState) => ({
      ...prevState,
      RecipientEmail: value, // Correctly update RecipientEmail
    }));
  };

  const AddToMailContent = (
    <Panel
      header="Mail Configuration"
      style={{ width: "400px", margin: "auto" }}
    >
      <div className="p-fluid">
        <div className="p-field">
          <label htmlFor="to">Recipient Mail</label>
          <div className="email-input">
            {emailAddresses.map((email, index) => (
              <span key={index} className="email-tag">
                {email}
                <Button
                  icon="pi pi-times"
                  className="p-button-rounded p-button-danger p-button-text"
                  onClick={() => handleRemoveEmail(index)}
                />
              </span>
            ))}

            {editedItems?.RecipientId == null ? (
              <>
                <input
                  type="text"
                  value={editedItems?.RecipientEmail || ""}
                  onChange={handleInputTooEmail}
                  onKeyDown={handleKeyDown}
                  placeholder="Enter emails, press Enter"
                  className="email-text-input"
                />
              </>
            ) : (
              <>
                <input
                  type="text"
                  value={editedItems?.RecipientEmail || ""}
                  onChange={handleInputTooEmail}
                  className="email-text-input"
                />
              </>
            )}
          </div>
          {errors.to && <small className="p-error">{errors.to}</small>}
          {errors.emailAddresses && (
            <small className="p-error">{errors.emailAddresses}</small>
          )}
        </div>
      </div>
    </Panel>
  );

  const handlehiddenPopup = () => {
    setErrors({});
    setEmailAddresses([]);
    setShowDialog(false);
  };

  const actionTemplate = (rowData) => {
    const handleActionClick = (e) => {
      e.stopPropagation();
    };
    const handleEdit = (rowData) => {
      setShowDialog(true);
      setEditedItems({ ...rowData });
    };

    const handleDelete = (rowdata) => {
      setEditedItems({ ...rowdata });
      setDeleteConfirmation(true);
    };
    return (
      <div onClick={handleActionClick}>
        <Button
          id="UserTOAccountEditIcon"
          icon={<MdModeEdit />}
          title="Edit"
          className="p-button-rounded p-button-primary p-mr-2"
          onClick={() => handleEdit(rowData)}
        />
        <Button
          id="UserTOAccountDeleteIcon"
          icon={<MdDelete />}
          title="Delete"
          className="p-button-rounded p-button-primary"
          onClick={() => {
            handleDelete(rowData);
          }}
        />
      </div>
    );
  };
  const handleConfirmDelete = async () => {
    if (editedItems.RecipientId) {
      const requestBody = {
        recipientId: editedItems.RecipientId,
      };
      const response = await DeleteAPICall(
        "api/Configuration/DeleteToMailConfiguration",
        requestBody
      );
      GetTooMail();
      setDeleteConfirmation(false);
      setEditedItems(null);
      showSuccessToast("Deleted Successfully..");
    }
  };
  const DeleteConfirmation = (
    <>
      <div>
        <Button
          style={{ borderRadius: "5px", padding: "15px" }}
          label="Yes"
          icon="pi pi-check"
          onClick={handleConfirmDelete}
          autoFocus
        />
        <Button
          style={{
            borderRadius: "5px",
            padding: "15px",
            backgroundColor: "lightslategray",
            color: "white",
          }}
          label="No"
          icon="pi pi-times"
          onClick={() => setDeleteConfirmation(false)}
          className="p-button-text"
        />
      </div>
    </>
  );
  return (
    <div>
      <Toast ref={toast} />
      <div
        id="plus_search"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <b
          style={{
            color: "lightslategray",
            marginRight: "auto",
            marginTop: "10px",
          }}
        >
          {props?.accountGroupName}
        </b>
        <Button
          icon={
            <IoAddOutline
              style={{ color: "darkslategrey", fontSize: "50px" }}
            />
          }
          id="MasterPlusicon"
          onClick={handlePopupOpen}
          className="p-button p-button-icon"
          title="Add"
        />
        <InputText
          id="AccountGroupSearch"
          type="search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search..."
        />
        <Button
          icon="pi pi-search"
          id="searchicon"
          style={{
            backgroundColor: "lightslategray",
            border: "lightslategray",
          }}
          className="p-button-primary"
          title="Search"
        />
      </div>
      <DataTable
        className="TomailDataTable"
        scrollable
        scrollHeight="440px"
        header="To Email"
        value={props?.toMailDataRemove == true ? "" : filteredToomailDataSource}
        dataKey="RecipientEmail" // Ensure unique key
      >
        <Column field="RecipientEmail" header="Recipient Email" sortable />
        <Column header="Actions" body={actionTemplate} />
      </DataTable>
      <GlobalPopup
        title="Recipient Mail"
        visible={showDialog}
        onHide={handlehiddenPopup}
        footerButtons={AddNewToMailFooter}
        content={AddToMailContent}
      />
      <GlobalPopup
        title={"Confirmation"}
        visible={deleteConfirmation}
        onHide={() => setDeleteConfirmation(false)}
        footerButtons={DeleteConfirmation}
        content={
          <div className="confirmation-content">
            Are you sure you want to delete this item?
          </div>
        }
      />
    </div>
  );
}
